import adminAPI from "../../api/apiAdmin";

class AdminCustomerService {
    static async getAll(params = {}) {
        const response = await adminAPI.get("/admin/customers", { params });
        return response.data;
    }

    static async getStats() {
        const response = await adminAPI.get("/admin/customers/stats");
        return response.data;
    }

    static async getDetail(id) {
        const response = await adminAPI.get(`/admin/customers/${id}`);
        return response.data;
    }

    static async update(id, data) {
        const response = await adminAPI.patch(`/admin/customers/${id}`, data);
        return response.data;
    }

    static async toggleBlock(id) {
        const response = await adminAPI.patch(`/admin/customers/${id}/toggle-block`);
        return response.data;
    }
}

export default AdminCustomerService;
